// Shared MUI field styling for the centred modals, next to tableTokens.js

// Centre the unshrunk label vertically; only for fields whose value is centred too
export const centeredLabelSx = {
  '&:not(.MuiInputLabel-shrink)': {
    width: '100%',
    textAlign: 'center',
    transformOrigin: 'top center',
    top: '50%',
    transform: 'translate(0, -50%) scale(1)',
  },
};

// For left-aligned values: vertical centring only, so the placeholder stays over the first column
export const verticallyCenteredLabelSx = {
  '&:not(.MuiInputLabel-shrink)': {
    top: '50%',
    transform: 'translate(14px, -50%) scale(1)',
  },
};

// Help text as its own element, since helperText would drag the centred label down
export const fieldHelpSx = {
  color: '#8fa3d4',
  fontSize: '14px',
  textAlign: 'center',
  mt: 0.5,
  mb: 2,
};
